import { Component } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { CardModule } from 'primeng/card';
import { DividerModule } from 'primeng/divider';

@Component({
  selector: 'app-unauthenticated-layout',
  imports: [RouterModule, RouterOutlet, DividerModule, CardModule],
  templateUrl: './unauthenticated-layout.component.html',
  styleUrl: './unauthenticated-layout.component.scss',
})
export class UnauthenticatedLayoutComponent {
  public constructor() {}
}
